import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div
      style={{
        padding: '50px',
        textAlign: 'center',
        minHeight: 'calc(100vh - 64px)',
      }}
    >
      <h2>404 - 页面不存在</h2>
      <p>抱歉，您访问的页面不存在。</p>
      <p>{countdown} 秒后自动返回首页...</p>
    </div>
  );
};

export default NotFound;
